import { render, staticRenderFns } from "./SystemInfoComponent.vue?vue&type=template&id=3793d9d2"
import script from "./SystemInfoComponent.vue?vue&type=script&lang=js"
export * from "./SystemInfoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports